<template>
  <div class="d-lg-flex half"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary'>
      <v-icon x-medium class="white--text">
        mdi-checkbox-marked-circle
      </v-icon>
      <span>
        {{ alert_err_attention }}
      </span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red'>
      <v-icon x-medium class="white--text">
        mdi-minus-circle
      </v-icon>
      <span>
        {{ alert_err_attention }}
      </span>
    </v-snackbar>
    <div class="bg order-1 order-md-2" style="background-image: url('banner-app-MedAn247.jpg');"></div>
    <div class="contents order-2 order-md-1">

      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="content col-md-7">
            <div class="align-items-center justify-content-center">
              <img src="logomedan.png" width="150" alt="" class="mb-4">
            </div>
            <h3>Register to <strong>Medan</strong></h3>
            <p class="mb-4">Please register to use Medan</p>
            <form action="#" method="post">

              <v-alert v-if="errors" type="error" class="mt-4">
                {{ errors }}
              </v-alert>
              <v-form v-model="formValid" ref="form" @submit.prevent="validateForm">
                <div class="form-group first mb-2">
                  <v-text-field
                    v-model="user.username"
                    outlined
                    dense
                    label="Username"
                    placeholder="johndoe"
                    prepend-inner-icon="mdi-account"
                    :rules="[v => !!v || 'Username is required']"
                  ></v-text-field>
                </div>

                <div class="form-group last mb-2">
                  <v-text-field
                    v-model="user.email"
                    outlined
                    dense
                    label="Email"
                    placeholder="johndoe@gmail.com"
                    prepend-inner-icon="mdi-email"
                    :rules="[v => !!v || 'Email is required']"
                  ></v-text-field>
                </div>

                <div class="form-group last mb-2">
                  <v-select
                    v-model="valueKeywordRole"
                    :items="itemsKeywordRole"
                    item-text="ROLE_NAME"
                    item-value="KEYWORD_ROLE_ID"
                    :rules="[v => !!v || 'Keyword Role is required']"
                    dense
                    outlined
                    prepend-inner-icon="mdi-account-group-outline"
                    label="Keyword Role"
                  ></v-select>
                </div>

                <div class="form-group last mb-2">
                  <v-text-field
                    v-model="user.password"
                    outlined
                    dense
                    persistent-hint
                    label="Password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showpassword ? 'mdi-eye' :'mdi-eye-off'"
                    :type="showpassword ? 'text' : 'password'"
                    @click:append="showpassword = !showpassword"
                    :rules="[v => !!v || 'Password is required']"
                  ></v-text-field>
                </div>

                <div class="form-group last mb-2">
                  <v-text-field
                    v-model="user.confirmPassword"
                    outlined
                    dense
                    persistent-hint
                    label="Confirm Password"
                    prepend-inner-icon="mdi-lock-check"
                    :append-icon="showconfirmpassword ? 'mdi-eye' :'mdi-eye-off'"
                    :type="showconfirmpassword ? 'text' : 'password'"
                    @click:append="showconfirmpassword = !showconfirmpassword"
                    :rules="[v => !!v || 'Confirm Password is required']"
                  ></v-text-field>
                </div>

                <v-btn
                  class="btn-block elevation-0 white--text"
                  style="text-decoration:none;"
                  color="#03779F"
                  block
                  large
                  rounded
                  dark
                  type="submit"
                >
                  Register
                </v-btn>
              </v-form>

              <div class="form-group d-flex justify-content-between">
                <label class="label mx-auto mt-1 font-weight-normal">
                  <p class="text-center mb-0 text-muted font-weight-light">
                    Already have account?
                    <v-btn to="/" text color="primary" style="text-decoration:none;">
                      Login here
                    </v-btn>
                  </p>
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="dialogRegister" :z-index="0">
      <div class="blur-background"></div>
      <v-dialog v-model="dialogRegister" persistent max-width="600px">
        <v-card class="pa-3" style="border-radius: 20px;">
          <v-card-text>
            <v-container>
              <v-stepper v-model="e1" flat class="mx-6">
                <v-stepper-items class="ma-0 pa-0">

                  <v-stepper-content step="1">
                    <v-card-title>
                      <span class="text-h5 mb-2 font-weight-medium">
                        What are you interested in?
                      </span>
                    </v-card-title>
                    <v-card flat height="360px" class="overflow-card">
                      <v-row class="align-center justify-center my-2">
                        <v-flex v-for="(item, i) in itemsInterested" :key="item.TOPIC_ID" lg4 class="text-center align-center justify-center">
                          <v-avatar color="orange" size="85" style="cursor: pointer" @click="getIdInterested(item, i)">
                            <img src="Politic.jpg" :alt="item.TOPIC_NAME">
                          </v-avatar>
                          <h2 style="width: 150px; text-wrap: wrap;" class="my-3">
                            {{ item.TOPIC_NAME }}
                            <v-icon v-if="item.isSelect == true">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </h2>
                        </v-flex>
                      </v-row>
                    </v-card>

                    <v-divider></v-divider>
                    <p v-if="messageError" style="color: red;" class="mt-2">
                      {{ messageError }}
                    </p>
                    <div class="mt-5 mb-2">
                      <v-btn disabled class="mx-2" outlined rounded color="primary">
                        Previous
                      </v-btn>
                      <v-btn rounded color="primary" @click="actionInterested">
                        Continue
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <div class="d-flex justify-end">
                      <v-icon @click="cancelRegister">
                        mdi-close
                      </v-icon>
                    </div>
                    <div class="mb-2">
                      <span class="text-h5 mb-2 font-weight-medium">
                        Pinned Famous People
                      </span>
                    </div>
                    <v-row>
                      <v-col cols="12" md="7">
                        <v-text-field
                          v-model="search"
                          class="pt-3 mr-4"
                          append-icon="mdi-magnify"
                          label="Search"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5" class="d-flex justify-end align-center">
                        <v-dialog v-model="dialogNewPerson" max-width="500px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" outlined rounded small color="primary" class="mb-2">
                              Add New Person
                              <v-icon class="ml-2">mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <v-form v-model="formValidPerson" ref="formPerson">
                            <v-card>
                              <v-card-title>
                                <v-card-title>
                                  <span class="text-h6">
                                    Add New Person
                                  </span>
                                </v-card-title>
                              </v-card-title>
                              <v-card-text style="height: 400px;" class="overflow-card">
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="userIdNewPerson"
                                        outlined
                                        dense
                                        :rules="userIdRules"
                                        label="Username Twitter"
                                        hint="Input Username Twitter without @"
                                        persistent-hint
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="userDisplayName"
                                        outlined
                                        dense
                                        :rules="displayNameRules"
                                        label="Username Display Name"
                                        hint="Input Username Display Name"
                                        persistent-hint
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-select
                                        v-model="userType"
                                        :items="itemsUserType"
                                        item-text="name"
                                        item-value="value"
                                        dense
                                        outlined
                                        hint="User type of famous person"
                                        persistent-hint
                                      ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-select
                                        v-model="statusActive"
                                        :items="itemsActive"
                                        item-text="name_active"
                                        item-value="valueactive"
                                        dense
                                        outlined
                                        hint="Active/Disable crawling person by system"
                                        persistent-hint
                                      ></v-select>
                                    </v-col>
                                    <v-col>
                                      <input dense outlined chips accept="image/*" type="file" ref="file" @change="selectfile">
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="image_url"
                                        outlined
                                        dense
                                        label="User Profile Image URL"
                                        hint="Input URL of image"
                                        persistent-hint
                                      ></v-text-field>
                                    </v-col>
                                    <v-row v-for="(item, index) in item_alias" :key="index" class="ma-0 pa-0 ml-3 mt-2">
                                      <v-flex lg8>
                                        <v-text-field
                                          v-model="item.alias"
                                          outlined
                                          dense
                                          label="User Alias"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4>
                                        <v-btn class="mx-2 elevation-0" dark outlined icon color="#0471A5" @click="add">
                                          <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn class="elevation-0" outlined color="#0471A5" icon @click="remove(item, index)">
                                          <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-row>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions class="py-3">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  style="width: 90px;"
                                  rounded
                                  outlined
                                  dense
                                  @click="close"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  style="width: 90px;"
                                  rounded
                                  dark
                                  dense
                                  :loading="btnLoading"
                                  @click="validateFormPerson"
                                >
                                  Save
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-form>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-card flat height="300px" class="overflow-card">
                      <v-row class="align-center justify-center my-2">
                        <v-flex v-for="(item, i) in searchItemsPerson" :key="item.SEQ_ID" lg4 class="text-center align-center justify-center">
                          <v-avatar color="orange" size="85" style="cursor: pointer" @click="getIdPerson(item, i)">
                            <img v-if="item.PRS_IMAGE != null" :src="serverPRSIMAGE + item.PRS_IMAGE" alt="Person">
                            <img v-if="item.PRS_IMAGE == null" src="../../public/person.png" alt="Person">
                          </v-avatar>
                          <h2 style="width: 150px; text-wrap: wrap;" class="my-3">
                            {{ item.USER_DISPLAY_NAME }}
                            <v-icon v-if="item.isSelect == true">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </h2>
                        </v-flex>
                      </v-row>
                    </v-card>

                    <v-divider></v-divider>
                    <div class="mt-5 mb-2">
                      <v-btn class="mx-2" outlined rounded color="primary" @click="e1 = 1">
                        Previous
                      </v-btn>
                      <v-btn rounded color="primary" @click="postPinnedPerson">
                        Continue
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <div class="d-flex justify-end">
                      <v-icon @click="cancelRegister">
                        mdi-close
                      </v-icon>
                    </div>
                    <div class="mb-2">
                      <span class="text-h5 mb-2 font-weight-medium">
                        Pinned Famous Entity
                      </span>
                    </div>
                    <v-row>
                      <v-col cols="12" md="7">
                        <v-text-field
                          v-model="searchOrganization"
                          class="pt-3 mr-4"
                          append-icon="mdi-magnify"
                          label="Search"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5" class="d-flex justify-end align-center">
                        <v-dialog v-model="dialogNewOrganization" max-width="500px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" outlined rounded small color="primary" class="mb-2">
                              Add New Entity
                              <v-icon class="ml-2">mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <v-form v-model="formValidOrganization" ref="formOrganization">
                            <v-card>
                              <v-card-title>
                                <v-card-title>
                                  <span class="text-h6">
                                    Add New Entity
                                  </span>
                                </v-card-title>
                              </v-card-title>
                              <v-card-text style="height: 400px;" class="overflow-card">
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="userOrganizationDisplayName"
                                        outlined
                                        dense
                                        :rules="organizationDisplayNameRules"
                                        label="Organization display name"
                                        hint="Input organization display name"
                                        persistent-hint
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                      <v-text-field
                                        v-model="userOrganizationAlias"
                                        outlined
                                        dense
                                        :rules="organizationAliasRules"
                                        label="Organization alias"
                                        hint="Input Organization alias"
                                        persistent-hint
                                      ></v-text-field>
                                    </v-col>
                                    <v-col>
                                      <input dense outlined chips accept="image/*" type="file" ref="file" @change="selectfileOrganization">
                                    </v-col>
                                    <v-row v-for="(item, index) in item_aliasOrganization" :key="index" class="ma-0 pa-0 ml-3 mt-2">
                                      <v-flex lg8>
                                        <v-text-field
                                          v-model="item.alias"
                                          outlined
                                          dense
                                          label="User Alias"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex lg4>
                                        <v-btn class="mx-2 elevation-0" dark outlined icon color="#0471A5" @click="addOrganization">
                                          <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn class="elevation-0" outlined color="#0471A5" icon @click="removeOrganization(item, index)">
                                          <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-row>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions class="py-3">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  style="width: 90px;"
                                  rounded
                                  outlined
                                  dense
                                  @click="closeOrganization"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  style="width: 90px;"
                                  rounded
                                  dark
                                  dense
                                  :loading="btnLoadingOrganization"
                                  @click="validateFormOrganization"
                                >
                                  Save
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-form>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-card flat height="300px" class="overflow-card">
                      <v-row class="align-center justify-center my-2">
                        <v-flex v-for="(item, i) in searchItemsOrganization" :key="item.SEQ_ID" lg4 class="text-center align-center justify-center">
                          <v-avatar color="orange" size="85" style="cursor: pointer" @click="getIdOrganization(item, i)">
                            <img v-if="item.ORG_IMAGE != null" :src="serverORGIMAGE + item.ORG_IMAGE" alt="Organization">
                            <img v-if="item.ORG_IMAGE == null" src="../../public/person.png" alt="Organization">
                          </v-avatar>
                          <h2 style="width: 150px; text-wrap: wrap;" class="my-3">
                            {{ item.ORG_DISPLAY_NAME }}
                            <v-icon v-if="item.isSelect == true">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </h2>
                        </v-flex>
                      </v-row>
                    </v-card>

                    <v-divider></v-divider>
                    <div class="mt-5 mb-2">
                      <v-btn class="mx-2" outlined rounded color="primary" @click="e1 = 2">
                        Previous
                      </v-btn>
                      <v-btn rounded color="primary" @click="postPinnedOrganization">
                        Finish
                      </v-btn>
                    </div>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <v-dialog
      v-model="dialogInfo"
      width="330px"
    >
      <v-card
        class="text-center align-center justify-center pa-6 rounded-lg"
        width="330px"
      >
        <v-avatar color="#eee" style="border: 2px solid #ddd;" size="80">
          <v-icon class="white--text" size="80">
            mdi-check
          </v-icon>
        </v-avatar>

        <h1 class="mt-2 text-center text-h6 align-center justify-center" style="text-wrap: wrap">
          Successful registration, please wait for approval from the admin
        </h1>

        <v-divider class="mt-4"></v-divider>

        <v-card-actions class="align-center justify-center">
          <v-btn
            color="#0471A5"
            width="120px"
            height="40px"
            style="borderRadius: 8px"
            size="large"
            dark
            @click="dialogInfo = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script type="JavaScript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.18/vue.min.js"></script>
<script>
import axios from "axios";
import { decryptionData,datetimenow } from '@/components/utils/utils.js';
import io from 'socket.io-client';
// alert(this.password)

export default {
  name: 'register',
  data () {
    return {
      socket: "",
      dialogInfo: false,
      itemsKeywordRole: [],
      valueKeywordRole: "",
      dialogRegister: false,
      e1: 1,
      registerUserId: "",
      itemsInterested: "",
      valueIdInterested: [],
      valueIdInterested2: [],
      messageError: "",
      search: "",
      itemsPerson: [],
      valueIdPerson: [],
      valueIdPerson2: [],

      dialogNewPerson: false,
      userIdNewPerson: "",
      userIdRules: [
        v => !!v || 'Username Twitter is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      userDisplayName: "",
      displayNameRules: [
        v => !!v || 'User Display Name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      userType: 0,
      itemsUserType: [
        { value: 0, name: "Twitter" },
        { value: 1, name: "Youtube" }
      ],
      statusActive: 1,
      itemsActive: [
        { valueactive: 1, name_active: "Active" },
        { valueactive: 0, name_active: "Disable" }
      ],
      file: "",
      image_url: "",
      item_alias: [
        { alias : '', id_alias : '' }
      ],
      formValidPerson: false,
      btnLoading: false,
      cancelIdPerson: [],
      cancelIdPerson2: [],
      isAddNewPerson: false,

      dialogNewOrganization: false,
      userOrganizationDisplayName: "",
      userOrganizationAlias: "",
      organizationDisplayNameRules: [
        v => !!v || 'Organization display name is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      organizationAliasRules: [
        v => !!v || 'Organization Alias is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      fileOrganization: "",
      item_aliasOrganization: [
        { alias : '', id_alias : '' }
      ],
      btnLoadingOrganization: false,
      formValidOrganization: false,
      cancelIdOrganization: [],
      cancelIdOrganization2: [],
      isAddNewOrganization: false,
      alertSuccess: "",
      alertFailed: "",
      alert_err_attention: "",

      searchOrganization: "",
      itemsOrganization: [],
      serverPRSIMAGE: "http://172.20.4.11:3333/upload/analyz_person/",
      serverORGIMAGE: "http://172.20.4.11:3333/upload/organization/",
      valueIdOrganization: [],
      valueIdOrganization2: [],
      showpassword: false,
      showconfirmpassword: false,
      errors: null,
      formValid: false,
      user: {}
    }
  },
  computed: {
    searchItemsPerson: function () {
      return this.itemsPerson.filter((itemsPerson) => {
        return itemsPerson.USER_DISPLAY_NAME
          .toLowerCase()
          .match(this.search.toLowerCase());
      });
    },
    searchItemsOrganization: function () {
      return this.itemsOrganization.filter((itemsOrganization) => {
        return itemsOrganization.ORG_DISPLAY_NAME
          .toLowerCase()
          .match(this.searchOrganization.toLowerCase());
      });
    },
  },
  watch: {
    dialogNewPerson(val) {
      val || this.close();
    },
    dialogNewOrganization(val) {
      val || this.closeOrganization();
    },
  },
  mounted() {
    this.getKeywordRole();
    this.loadItemsPerson();
    this.loadItemsOrganization();
  },
  methods: {
    async getKeywordRole() {
      try {
        const data1 = await axios.get(
          "keyword_role_public",
        );

        const data = data1.data;
        this.itemsKeywordRole = data.role_keyword;
      } catch (e) {
        console.log(e);
      }
    },
    async getItemsInterested(data) {
      for (let i = 0; i < data.length; i++) {
        this.itemsInterested[i].isSelect = data[i].SELECTED;
        if (data[i].SELECTED == true) {
          this.valueIdInterested.push(data[i].TOPIC_ID);
          let originalArray = this.valueIdInterested;

          let valueIdInterested = originalArray.map(value => {
            return {
              "topic_id": value.toString()
            };
          });

          this.valueIdInterested2 = valueIdInterested;
        }
      }
    },
    getIdInterested(item, i) {
      if (this.valueIdInterested.includes(item.TOPIC_ID)) {
        const indexToRemove = this.valueIdInterested.indexOf(item.TOPIC_ID);
        this.valueIdInterested.splice(indexToRemove, 1);
        this.$set(this.itemsInterested, i, { ...item, isSelect: false });
      } else {
        this.valueIdInterested.push(item.TOPIC_ID);
        this.$set(this.itemsInterested, i, { ...item, isSelect: true });
      }
      let originalArray = this.valueIdInterested;

      let valueIdInterested = originalArray.map(value => {
        return {
          "topic_id": value.toString()
        };
      });

      this.valueIdInterested2 = valueIdInterested;
    },
    async actionInterested() {
      try {
        const data1 = await axios.post(
          "action_topic_access_control",
          {
            "user_id": this.registerUserId,
            "keyword_role_id": this.valueKeywordRole,
            "topic": this.valueIdInterested2
          },
        );

        const data = data1.data;
        if (data.status == 200 || data.status == 201) {
          this.e1 = 2;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loadItemsPerson() {
      try {
        const data1 = await axios.get(
          "/person_public",
        );

        const data = data1.data;
        this.itemsPerson = data.person;
        if (this.isAddNewPerson == false) {
          for (let i = 0; i < this.itemsPerson.length; i++) {
            this.itemsPerson[i].isSelect = false;
          }
        }
        if (this.isAddNewPerson == true) {
          for (let i = 0; i < this.itemsPerson.length; i++) {
            this.itemsPerson[i].isSelect = this.valueIdPerson.includes(this.itemsPerson[i].SEQ_ID);
          }
        }
        this.isAddNewPerson = false;
      } catch (e) {
        console.log(e);
      }
    },
    getIdPerson(item, i) {
      if (this.valueIdPerson.includes(item.SEQ_ID)) {
        const indexToRemove = this.valueIdPerson.indexOf(item.SEQ_ID);
        this.valueIdPerson.splice(indexToRemove, 1);
        this.$set(this.itemsPerson, i, { ...item, isSelect: false });
      } else {
        this.valueIdPerson.push(item.SEQ_ID);
        this.$set(this.itemsPerson, i, { ...item, isSelect: true });
      }
      let originalArray = this.valueIdPerson;

      let valueIdPerson = originalArray.map(value => {
        return {
          "PERSON_ID": value.toString()
        };
      });

      this.valueIdPerson2 = valueIdPerson;
    },
    async postPinnedPerson() {
      try {
        const data1 = await axios.post(
          "/insert_pinned_person_public",
          {
            "user_id": this.registerUserId,
            "pinned_person": this.valueIdPerson2,
          },
        );

        const data = data1.data;
        if (data.status == 200 || data.status == 201) {
          this.e1 = 3;
        }
      } catch (e) {
        console.log(e);
      }
    },
    selectfile() {
      this.file = this.$refs.file.files[0];
    },
    selectfileOrganization() {
      this.fileOrganization = this.$refs.file.files[0];
    },
    add() {
      this.originalData = null;
      this.item_alias.push({ alias: '', id_alias: '' });
    },
    addOrganization() {
      this.originalData = null;
      this.item_aliasOrganization.push({ alias: '', id_alias: '' });
    },
    remove(item, index) {
      if (item.id_alias != null) {
      }
      if (index > 0) {
        this.item_alias.splice(index, 1);
      } else {
        alert('Baris Pertama tidak bisa dihapus');
      }
    },
    removeOrganization(item, index) {
      if (item.id_alias != null) {
      }
      if (index > 0) {
        this.item_aliasOrganization.splice(index, 1);
      } else {
        alert('Baris Pertama tidak bisa dihapus');
      }
    },
    close() {
      this.dialogNewPerson = false;
    },
    closeOrganization() {
      this.dialogNewOrganization = false;
    },
    validateFormPerson() {
      if (this.$refs.formPerson.validate()) {
        this.saveNewPerson();
      }
    },
    async saveNewPerson() {
      try {
        this.btnLoading = true;
        var arr_alias = [];
        var seq_id_alias = [];
        for (var alias of this.item_alias) {
          arr_alias.push(alias.alias);
          seq_id_alias.push(alias.id_alias);
        }
        const formData = new FormData();
        formData.append('user_id_tweet', this.userIdNewPerson);
        formData.append('user_follower_count', '');
        formData.append('user_status', this.statusActive);
        formData.append('user_profile_img_url', this.image_url);
        formData.append('user_type', this.userType);
        formData.append('user_id', this.registerUserId);
        formData.append('image', this.file);
        formData.append('user_alias', arr_alias);
        formData.append('user_display_name', this.userDisplayName);

        const response = await axios.post("/public/person/insert", formData, {
          headers: {
            'accept': '*/*',
            'Content-Type': 'multipart/form-data'
          }
        });

        var status = response.data.status;
        var messages = response.data.msg;
        var personIdCreate = response.data.person_id_create;
        if (status == 200) {
          this.isAddNewPerson = true;
          this.loadItemsPerson();
          this.alertSuccess = true;
          this.alert_err_attention = messages;
          this.btnLoading = false;
          this.close();

          this.cancelIdPerson.push(personIdCreate);

          let valueIdPerson = this.cancelIdPerson.map(value => {
            return {
              "PERSON_ID": value.toString()
            };
          });

          this.cancelIdPerson2 = valueIdPerson;
        } else {
          this.alertFailed = true;
          this.alert_err_attention = messages;
          this.btnLoading = false;
        }
      } catch (error) {
        switch (e.response.status) {
        case 404:
          this.$refs.alert.error_login(404);
          break;
        case 403:
          this.$refs.alert.error_login(403);
          break;
        case 400:
          this.alertFailed = true;
          this.alert_err_attention = e.response.data.msg;
          break;
        default:
          console.log('some other error'); // end up here all the time
          break;
        }
        this.errors = e.response.data.msg;
      }
    },
    async cancelRegister() {
      try {
        const data1 = await axios.delete(
          "/cancle_register",
          {
            data: {
              "user_id_register": this.registerUserId,
              "person_create": this.cancelIdPerson2,
              "organization_created": this.cancelIdOrganization2
            }
          }
        );

        var status = data1.data.status;
        var messages = data1.data.msg;
        if (status == 200) {
          this.alertSuccess = true;
          this.alert_err_attention = messages;
          this.dialogRegister = false;
          this.e1 = 1;
          this.cancelIdPerson = [];
          this.cancelIdPerson2 = [];
          this.cancelIdOrganization = [];
          this.cancelIdOrganization2 = [];
          this.loadItemsPerson();
          this.loadItemsOrganization();
        } else {
          this.alertFailed = true;
          this.alert_err_attention = messages;
          this.dialogRegister = true;
        }
      } catch (e) {
        switch (e.response.status) {
        case 404:
          this.$refs.alert.error_login(404);
          break;
        case 403:
          this.$refs.alert.error_login(403);
          break;
        case 400:
          this.alertFailed = true;
          this.alert_err_attention = e.response.data.msg;
          break;
        default:
          console.log('some other error'); // end up here all the time
          break;
        }
        this.errors = e.response.data.msg;
      }
    },
    async loadItemsOrganization() {
      try {
        const data1 = await axios.get(
          "/organization_public",
        );

        const data = data1.data;
        this.itemsOrganization = data.organization;
        if (this.isAddNewOrganization == false) {
          for (let i = 0; i < this.itemsOrganization.length; i++) {
            this.itemsOrganization[i].isSelect = false;
          }
        }
        if (this.isAddNewOrganization == true) {
          for (let i = 0; i < this.itemsOrganization.length; i++) {
            this.itemsOrganization[i].isSelect = this.valueIdOrganization.includes(this.itemsOrganization[i].SEQ_ID);
          }
        }
        this.isAddNewOrganization = false;
      } catch (e) {
        console.log(e);
      }
    },
    getIdOrganization(item, i) {
      if (this.valueIdOrganization.includes(item.SEQ_ID)) {
        const indexToRemove = this.valueIdOrganization.indexOf(item.SEQ_ID);
        this.valueIdOrganization.splice(indexToRemove, 1);
        this.$set(this.itemsOrganization, i, { ...item, isSelect: false });
      } else {
        this.valueIdOrganization.push(item.SEQ_ID);
        this.$set(this.itemsOrganization, i, { ...item, isSelect: true });
      }
      let originalArray = this.valueIdOrganization;

      let valueIdOrganization = originalArray.map(value => {
        return {
          "ORGANIZATION_ID": value.toString()
        };
      });

      this.valueIdOrganization2 = valueIdOrganization;
    },
    async postPinnedOrganization() {
      try {
        
        // this.socket = io('http://172.20.4.11:3333'); // Connect to your Socket.io server
        // this.socket.emit('message', { 
        //     type: 'notifikasi_register',//type ini untuk mengategorikan jenis data yg ada di socket.io
        //     text: 'Username '+this.user.username+' created register user Medan247',
        //     username: 'Username',
        //     url: '/registrasiuser',
        //     date: datetimenow(),
        //   });
          
        const data1 = await axios.post(
          "/insert_pinned_organization_public",
          {
            "user_id": this.registerUserId,
            "pinned_organization": this.valueIdOrganization2,
          },
        );

        const data = data1.data;
        
        if (data.status == 200 || data.status == 201) {
          this.dialogRegister = false;
          this.dialogInfo = true;
          this.socket = io(process.env.VUE_APP_API_SOCKET); // Connect to your Socket.io server

          const now = new Date().toISOString();
          this.socket.emit('message', { 
            type: 'notifikasi_register',//type ini untuk mengategorikan jenis data yg ada di socket.io
            text: 'Username <b>'+this.user.username+'</b> created register user Medan247',
            username: 'Username',
            url: '/registrasiuser',
            date: now,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    validateFormOrganization() {
      if (this.$refs.formOrganization.validate()) {
        this.saveNewOrganization();
      }
    },
    async saveNewOrganization() {
      try {
        this.btnLoadingOrganization = true;
        var arr_alias = [];
        var seq_id_alias = [];
        for (var alias of this.item_aliasOrganization) {
          arr_alias.push(alias.alias);
          seq_id_alias.push(alias.id_alias);
        }
        const formData = new FormData();
        formData.append('org_display_name', this.userOrganizationDisplayName);
        formData.append('org_alias', this.userOrganizationAlias);
        formData.append('arr_alias', arr_alias);
        formData.append('image', this.fileOrganization);

        const response = await axios.post("/public/organization/insert", formData, {
          headers: {
            'accept': '*/*',
            'Content-Type': 'multipart/form-data'
          }
        });

        var status = response.data.status;
        var messages = response.data.msg;
        var organizationIdCreate = response.data.organization_id_created;
        if (status == 200) {
          this.isAddNewOrganization = true;
          this.loadItemsOrganization();
          this.alertSuccess = true;
          this.alert_err_attention = messages;
          this.btnLoadingOrganization = false;
          this.closeOrganization();

          this.cancelIdOrganization.push(organizationIdCreate);

          let valueIdOrganization = this.cancelIdOrganization.map(value => {
            return {
              "ORGANIZATION_ID": value.toString()
            };
          });

          this.cancelIdOrganization2 = valueIdOrganization;
        } else {
          this.alertFailed = true;
          this.alert_err_attention = messages;
          this.btnLoadingOrganization = false;
        }
      } catch (error) {
        switch (e.response.status) {
        case 404:
          this.$refs.alert.error_login(404);
          break;
        case 403:
          this.$refs.alert.error_login(403);
          break;
        case 400:
          this.alertFailed = true;
          this.alert_err_attention = e.response.data.msg;
          break;
        default:
          console.log('some other error'); // end up here all the time
          break;
        }
        this.errors = e.response.data.msg;
      }
    },
    validateForm() {
      if (this.$refs.form.validate()) {
        this.registerUser();
      }
    },
    registerUser() {
      axios.post(`register`, {
        username: this.user.username,
        email: this.user.email,
        password: this.user.password,
        confPassword: this.user.confirmPassword,
        keyword_role_id: this.valueKeywordRole
      })
      .then((response) => {
        if (response.data.status == 200 || response.data.status == 201) {
          this.dialogRegister = true;
          this.registerUserId = response.data.data.USER_ID;
          this.itemsInterested = response.data.data.TOPIC_INTERESTED;
          for (let i = 0; i < this.itemsInterested.length; i++) {
            this.itemsInterested[i].isSelect = false;
          }
          this.getItemsInterested(response.data.data.TOPIC_INTERESTED);
          // location.href = "/";
        }
      })
      .catch((e) => {
        // alert(e.response.data.msg);
        // console.log(error);
        this.errors = e.response.data.msg;
        setTimeout(() => {
          this.errors = "";
        }, 5000);
        // location.href = "/register";
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  z-index: -1;
}
body {
  font-family: "Roboto", sans-serif;
  background-color: #fff;
}

p {
  color: #707070;
  font-weight: 300;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: "Roboto", sans-serif;
}

a:hover {
  text-decoration: none !important;
}

.content {
  padding: 5rem 0;
  margin-left: 7rem;
  margin-right: 7rem;
}

h2 {
  font-size: 20px;
}

.half, .half .container > .row {
  height: 100%;
  min-height: 500px;
}

@media (max-width: 991.98px) {
  .half .bg {
    height: 400px;
  }
}

.half .contents {
  background: #ffffff;
}

.half .contents, .half .bg {
  width: 50%;
}
@media (max-width: 1199.98px) {
  .half .contents, .half .bg {
    width: 100%;
  }
}
.half .contents .form-control, .half .bg .form-control {
  border: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 54px;
  background: #fff;
}
.half .contents .form-control:active, .half .contents .form-control:focus, .half .bg .form-control:active, .half .bg .form-control:focus {
  outline: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.half .bg {
  background-size: cover;
  background-position: center;
}

.half a {
  color: #888;
  text-decoration: underline;
}

.half .btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>